export default __webpack_public_path__ + "static/media/Gilroy-Regular.b1dbb51a.woff2";